import api from '../helpers/api';

import { UNSUBSCRIBE_FAILED, UNSUBSCRIBE_SUCCESS } from '../reducers/unsubscribe';

export function unsubscribe(token) {
  return (dispatch) => {
    return api.put('/misc/unsubscribe', {}, (token ? { 'X-Auth-Token': token } : {}))
      .then(() => {
        dispatch({
          type: UNSUBSCRIBE_SUCCESS,
        });
      }, () => {
        dispatch({
          type: UNSUBSCRIBE_FAILED,
        });
      });
  };
}

export default {
  unsubscribe,
};
